// # #############################################
// # Title : Pricing Details
// # Authors : Sameer, Dhruv, Shubham, Mahesh
// # Date : 15th October 2019
// # Last Modified : Dhruv, October 2019
// # Version : 19.10.03
// # Description : This is the code for the Component for End of Simulation Summary
// # ############################################

// Import required Libraries

import React from "react";
import "../css/App.css";
import PieChart from "../components/PieChart";
import HorizontalbarChart from "./HorizontalBarChart";
import CircularProgress from "@material-ui/core/CircularProgress";
import config from "../utils/config";
import ConsumerSegmentsDialogue from './ConsumerSegmentsInfo'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SpiderChart from "./SpiderChart";
import HorizontalBarChart from "./HorizontalBarChart";

import Tooltip from '@material-ui/core/Tooltip'

let chartColors = ["#344955"];
let chartColor = ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"];

function convertRange(value, r1, r2) {
  // Function to convert taste ,pleasure and health to stars
  return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
}

// Component for End of Simulation Summary
class PricingDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //default state
      compData: [],
      priceData: [],
      spends: 0,
      reach: 0,
      units_sold: 0,
      segments_count: [],
      graphdata: { name: "Units Sold", data: [] },
      openDialogue: false,
      width: "md",
    }
  }

  componentDidMount() {

    this.getUnitsSold();
    this.getSegments();
    if (sessionStorage.getItem("namespace") === "openScenario") {
      this.getCompData();
    }
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  getPromoReach() {
    this.props.subscribe_ns("channel_ad_reach", data => {
      console.log(data)
    });
  }

  getSegments() {

    let segments_count = [];

    //Segments for your brand and data for Horizontal chart

    this.props.subscribe_ns("brand_choice_vs_segment", data => {
      data.forEach(set => {
        let temp = {}
        if (set[1] === "Your Brand") {
          temp.name = set[0];
          temp.y = set[2];
          segments_count.push(temp)
        }
      })

      segments_count = segments_count.sort(function (a, b) {
        return b.y - a.y;
      })
      let count = 0;
      segments_count.forEach(o => {
        count = count + o.y
      })
      segments_count = segments_count.slice(0, 3)
      segments_count.forEach(o => {
        o.y = Math.round(o.y / count * 100)
      })
      this.setState({
        segments_count: segments_count
      });
    });
  }

  getUnitsSold() {

    //unit solds and data for Pie chart

    this.props.subscribe_ns("brand_choice_by_day_high", data => {

      let pieData = { name: "Units Sold", data: [], colorByPoint: true };
      let units_sold = 0;

      data.forEach(key => {
        let temp = {}
        if (key.name === "Your Brand") {
          temp.sliced = true;
          temp.selected = true;
          units_sold = key.data[key.data.length - 1][1];
        }
        temp['name'] = key.name;
        temp['y'] = key.data[key.data.length - 1][1];
        pieData.data.push(temp)
      })
      this.setState({
        graphdata: pieData,
        units_sold: units_sold,
      });
    });
  }

  getCompData() {
    // Function to get Competitor data
    fetch(config.api.url + "competitor/" + config.scenarioId, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      headers: {
        Authorization: `${config.token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {

        for (let i = 0; i < data["Product_attributes"].length; i++) {
          let temp = data.Product_attributes[i].brand;
          if (temp === 0) {
            data.Product_attributes[i].brand = "YourBrand"
          }
          else {
            data.Product_attributes[i].brand = "Competitor_" + i;
          }
        }

        let temp_health = { name: "Health" };
        let temp_taste = { name: "Taste" };
        let temp_pleasure = { name: "Pleasure" };
        for (let i = 0; i < data["Product_attributes"].length; i++) {
          temp_health[
            data["Product_attributes"][i]["brand"]
          ] = convertRange(
            data["Product_attributes"][i]["health"],
            [-4, 11], // On a scale of 0 to 11
            [0, 11]
          ).toFixed(2);
          temp_taste[data["Product_attributes"][i]["brand"]] = convertRange(
            data["Product_attributes"][i]["taste"],
            [-4, 11], // On a scale of 0 to 11
            [0, 11]
          ).toFixed(2);
          temp_pleasure[
            data["Product_attributes"][i]["brand"]
          ] = convertRange(
            data["Product_attributes"][i]["pleasure"],
            [-4, 11], // On a scale of 0 to 11
            [0, 11]
          ).toFixed(2);
        }

        let temp_price = [];
        if (data.Product_attributes && data.Product_attributes.length > 0) {
          data.Product_attributes.forEach(o => {
            temp_price.push({
              y: o.price,
              name: o.brand
            });
          });
        }

        this.setState({
          compData: [temp_health, temp_pleasure, temp_taste],
          priceData: temp_price
        });
      });
  }

  countComp = () => {
    // Count the number of competitors
    let result = 0;

    result = this.state.graphdata.length;

    if (result === 0) {
      return false;
    } else {
      return true;
    }
  };

  calcPos = () => {
    const graphData = this.state.graphdata;
    let yourBrand = [];
    let brandValue = 0;

    yourBrand = graphData.data.filter(x => { return x.name === "Your Brand" });

    if (yourBrand.length === 1) {
      brandValue = yourBrand[0].y

      let temp = [];

      graphData.data.forEach(x => { temp.push(x.y) })

      let marketPosition = graphData.data.length + 1;

      temp.forEach(x => {
        if (x <= brandValue) {
          marketPosition = marketPosition - 1;
        }
      })

      return marketPosition
    }
    else {
      return "NA"
    }

  };

  handleClickOpen = () => {
    this.setState({
      openDialogue: true
    })
  };

  handleClose = () => {
    this.setState({
      openDialogue: false
    })
  };


  updateWindowDimensions = () => {

    if (window.innerWidth < 1200) {
      this.setState({ width: "sm" });
    }

    else if (window.innerWidth >= 1200) {
      this.setState({ width: "md" });
    }

  }

  render() {

    let result = this.calcPos();
    let comps = this.countComp();

    let agents = 0;
    let duration = 0;

    if (sessionStorage.getItem('simSettings')) {
      const simSettings = JSON.parse(sessionStorage.getItem('simSettings'));
      agents = simSettings.accordians[0].content[0].selectedValue;
      duration = simSettings.accordians[0].content[1].selectedValue / 24;
    }
    else {
      const scenarioDetail = JSON.parse(sessionStorage.getItem("scenarioDetail"));
      agents = scenarioDetail[0].numAgents;
      duration = parseInt(scenarioDetail[0].n_ticks) / 24;
      result = scenarioDetail[0].marketPosition;
    }

    if (duration === 0) {
      return (
        <div className="graphLoader">
          <CircularProgress size={80} />
        </div>
      );
    } else {
      return (
        <div
          classname="mainsimdiv"
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            background: "whitesmoke"
          }}
        >
          <div
            className="firstdiv"
            style={{
              height: "15%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "2%"
            }}
          >
            <div className="marketposdiv" style={{ width: "36%" }}>
              <div style={{ fontSize: "2.5vw" }}>
                {`#`}
                {result}
              </div>
              <div>Market Position</div>
            </div>

            <div
              style={{ marginRight: "4%", marginLeft: "11%" }}
              className="agentdatadiv"
            >
              <table
                background="#98a5ad57"
                style={{
                  display: "inline-block",
                  marginTop: "1vh",
                  border: "2px solid #344955",
                  borderRadius: "5px",
                  borderCollapse: "collapse"
                }}
              >
                <tbody>
                  <tr>
                    <td>Number of agents</td>
                    <td>{agents}</td>
                  </tr>
                  <tr>
                    <td>Simulation duration</td>
                    <td>{`${duration} Day(s)`}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {comps ? (
            <div style={{ marginLeft: "-3%" }}>
              <PieChart key={new Date()} data={this.state.graphdata} />
            </div>
          ) : (
              <div>
                No product was bought either from Your Brand or the Competitors
            </div>
            )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              margin: "0 7%",
              paddingBottom: "1%",
              paddingTop: "3%"
            }}
          >
            <div style={{ width: "50%" }}>
              Average Units Sold :{" "}
              {(
                this.state.units_sold / duration
              ).toFixed(2)}
              /day
            </div>
            <div style={{ width: "50%", textAlign: "right" }}>
              Total Units Sold : {this.state.units_sold}
            </div>
          </div>
          {this.state.segments_count.length === 0 ? (
            <div style={{ height: "28%", padding: "5vw" }}>
              <div>Sorry, people didn't consume your product</div>
            </div>
          ) : (
              <div style={{ height: "35%" }}>
                <div style={{ fontSize: '0.9rem', display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                  Top segments who consumed your product
                <Tooltip placement="top" title="Click to view info about various customer segments" >
                    <InfoOutlinedIcon onClick={this.handleClickOpen} id={"pricingWidget_consumerInfoIcom"} color="disabled" />
                  </Tooltip>
                </div>
                <HorizontalbarChart
                  title=" "
                  data={this.state.segments_count}
                  colors={chartColors}
                  tooltip={true}
                  yTitle={"Percentage"}
                  label={"{y}%"}
                />
                <ConsumerSegmentsDialogue
                  open={this.state.openDialogue}
                  onClose={this.handleClose}
                  maxWidth={this.state.width}
                  handleClose={this.handleClose}
                />
              </div>
            )}
          {
            sessionStorage.getItem("namespace") === "openScenario" ?
              (
                <div>
                  <div className='compTitle' style={{ "margin-top": "3%" }}>Product Prices and Attributes</div>
                  <div className='compCharts'>
                    <div className='compBarChart'>
                      <HorizontalBarChart
                        data={this.state.priceData}
                        color="whitesmoke"
                        colors={chartColor}
                        yTitle={"Price"}
                        // eslint-disable-next-line
                        label={"${y}"}
                        tooltip={true}
                        title={null}
                        showProductInfo={true}
                      // key={`${new Date()}`}
                      />
                    </div>
                    <div className='compSpiderChart'>
                      <SpiderChart
                        openScenario={sessionStorage.getItem("namespace") === "openScenario"}
                        compData={this.state.compData}
                        colors={chartColor}
                      />
                    </div>
                  </div>
                </div>
              ) : null
          }
        </div>
      );
    }
  }
}

export default PricingDetails;
